"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../../utils");
/**
 * Class to handle all review summary data parsing and formatting
 */
class ReviewSummaryParser {
    constructor(reviewSummaries) {
        if (reviewSummaries.length < 1) {
            throw Error("At least one review summary is required");
        }
        this._reviewSummaries = reviewSummaries;
    }
    _parseAndFormatReviewSamples() {
        return this._reviewSummaries.reduce((acc, reviewSummary) => {
            const { samples } = reviewSummary;
            const formattedReviewSamples = samples.map((sampleReview) => {
                const { targets } = sampleReview;
                let sampleStatus = sampleReview.passed
                    ? "PASS"
                    : "FAIL";
                let sampleResult = sampleReview.passed
                    ? sampleReview.overallResult
                    : `Invalid-${sampleReview.overallResult}`;
                let approvalStatus = "";
                if (reviewSummary.reviewerRole === "user" &&
                    sampleReview.passed &&
                    sampleResult.toLowerCase() === "positive") {
                    approvalStatus = "Pending Review: Needs Supervisor Approval";
                    sampleStatus = "PENDING";
                    sampleResult = `Pending ${sampleResult}`;
                }
                const formattedReviewSample = {
                    sampleId: sampleReview.sampleName,
                    sampleType: sampleReview.sampleType,
                    sampleComments: this._formatNullableStringValue(sampleReview.comments),
                    sampleFailureReason: this._formatNullableStringValue(sampleReview.failureReason),
                    patientLogDate: (0, utils_1.SQLTimestampToDate)(reviewSummary.date),
                    runName: reviewSummary.run,
                    runReviewerName: reviewSummary.reviewerName,
                    runReviewerRole: reviewSummary.reviewerRole,
                    runProtocol: reviewSummary.protocol,
                    runPassed: reviewSummary.passed ? "Yes" : "No",
                    runComments: this._formatNullableStringValue(reviewSummary.comments),
                    targets: targets.map((target) => this._parseAndFormatReviewTarget(target)),
                    sampleStatus,
                    sampleResult,
                    approvalStatus,
                };
                return formattedReviewSample;
            });
            return [...acc, ...formattedReviewSamples];
        }, []);
    }
    _parseAndFormatReviewTarget(target) {
        const { cqOverride, comments, cq, targetName } = target;
        return {
            targetName,
            cq: cq.toString(),
            cqOverride: cqOverride ? "Yes" : "No",
            comments: this._formatNullableStringValue(comments),
        };
    }
    _formatNullableStringValue(value) {
        if (!value || (value && value.length < 1)) {
            return ReviewSummaryParser._EMPTY_PLACEHOLDER;
        }
        return value;
    }
    getReviewTargetNames() {
        return [
            ...new Set(this._reviewSummaries.reduce((acc, review) => {
                const { samples } = review;
                const uniqueReviewTargetNames = [
                    ...new Set(samples.reduce((acc, sample) => {
                        const { targets } = sample;
                        return [...acc, ...targets.map((target) => target.targetName)];
                    }, [])),
                ];
                return [...acc, ...uniqueReviewTargetNames];
            }, [])),
        ];
    }
    getParsedAndFormattedReviewSamples() {
        return this._parseAndFormatReviewSamples();
    }
}
ReviewSummaryParser._EMPTY_PLACEHOLDER = "N/A";
exports.default = ReviewSummaryParser;
